import React from 'react';

const Visa = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" aria-label="Visa" role="img">
    <rect width="48" height="32" rx="4" fill="#1A1F71" />
    <path d="M19.6 21.6h-2.9l1.8-11.2h2.9l-1.8 11.2zm10.6-10.9c-.6-.2-1.5-.5-2.6-.5-2.9 0-4.9 1.5-4.9 3.7 0 1.6 1.5 2.5 2.6 3 1.1.6 1.5.9 1.5 1.4 0 .7-.9 1.1-1.8 1.1-1.2 0-1.8-.2-2.8-.6l-.4-.2-.4 2.5c.7.3 2 .6 3.3.6 3.1 0 5-1.5 5.1-3.8 0-1.3-.8-2.2-2.5-3-1-.5-1.7-.9-1.7-1.4 0-.5.5-1 1.7-1 1 0 1.7.2 2.2.4l.3.1.4-2.3zm7.4-.3h-2.2c-.7 0-1.2.2-1.5.9l-4.3 10.3h3.1l.6-1.7h3.7l.4 1.7H40l-2.4-11.2zm-3.6 7.2l1.2-3.1.3-.9.2.9.7 3.1H34zM14.3 10.4l-2.9 7.6-.3-1.6c-.5-1.8-2.2-3.7-4.1-4.7l2.6 9.8h3.1l4.6-11.2h-3z" fill="#fff" />
    <path d="M8.8 10.4H4l-.1.2c3.7.9 6.1 3.2 7.2 5.9l-1-5.2c-.2-.7-.7-.9-1.3-.9z" fill="#F9A533" />
  </svg>
);

const Mastercard = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" aria-label="Mastercard" role="img">
    <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
    <circle cx="19" cy="16" r="8" fill="#EB001B" />
    <circle cx="29" cy="16" r="8" fill="#F79E1B" />
    <path d="M24 9.6a8 8 0 0 1 0 12.8 8 8 0 0 1 0-12.8z" fill="#FF5F00" />
  </svg>
);

const Amex = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" aria-label="American Express" role="img">
    <rect width="48" height="32" rx="4" fill="#2E77BC" />
    <text x="24" y="19.5" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="9" fill="#fff" letterSpacing="0.5">AMEX</text>
  </svg>
);

const Oxxo = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" aria-label="OXXO" role="img">
    <rect width="48" height="32" rx="4" fill="#EC1C24" />
    <rect x="3" y="7" width="42" height="18" rx="2" fill="#FFD400" />
    <rect x="5" y="9" width="38" height="14" rx="1.5" fill="#EC1C24" />
    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="10" fill="#fff">OXXO</text>
  </svg>
);

const Spei = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" aria-label="SPEI" role="img">
    <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
    <path d="M8 20l4-8h3l-4 8H8z" fill="#00A99D" />
    <path d="M12.5 20l4-8h3l-4 8h-3z" fill="#1B3A6B" />
    <text x="32" y="20" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="9.5" fill="#1B3A6B">SPEI</text>
  </svg>
);

const METHODS = [
  { key: 'visa', Logo: Visa, label: 'Visa' },
  { key: 'mastercard', Logo: Mastercard, label: 'Mastercard' },
  { key: 'amex', Logo: Amex, label: 'American Express' },
  { key: 'oxxo', Logo: Oxxo, label: 'OXXO · pago en efectivo' },
  { key: 'spei', Logo: Spei, label: 'SPEI · transferencia' },
];

export const PaymentMethods = () => (
  <div className="mt-5 pt-5 border-t" data-testid="payment-methods">
    <p className="text-sm font-semibold text-gray-800 mb-3">Medios de Pago Aceptados</p>
    <div className="flex flex-wrap items-center gap-2">
      {METHODS.map(({ key, Logo, label }) => (
        <span key={key} title={label} className="inline-flex rounded-md shadow-sm hover:-translate-y-0.5 transition-transform" data-testid={`payment-logo-${key}`}>
          <Logo />
        </span>
      ))}
    </div>
    <p className="text-xs text-gray-500 mt-2">Tarjetas de crédito y débito, efectivo en OXXO y transferencia SPEI.</p>
  </div>
);
